import { render } from "./TagManager.vue?vue&type=template&id=08daa2f0&scoped=true"
import script from "./TagManager.vue?vue&type=script&lang=js"
export * from "./TagManager.vue?vue&type=script&lang=js"

import "./TagManager.vue?vue&type=style&index=0&id=08daa2f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08daa2f0"]])

export default __exports__